import { gql } from "@apollo/client";

export const GET_CUSTOMERS = gql`
  query GetCustomers {
    getCustomers {
      id
      customer
      category
      displayUsername
      contactName
      email
      wastes {
        wasteTypeId
        wasteType
      }
      sites {
        customerSite
        id
      }
      pageAuth {
        financialPage
        weightingPage
        sustainabilityAudit
        reportingPage
      }
      sustainabilityAudit {
        documentType
        customerName
        fileName
        fileType
        lastModifiedDate
        filePath
      }
      weightingPlatform {
        documentType
        customerName
        fileName
        fileType
        lastModifiedDate
        filePath
      }
    }
  }
`;

export const GET_HOME_DATA = gql`
  query GetHomeData($input: DataInput) {
    getHomeData(input: $input) {
      dahsboardKPI {
        serviceRate
        totalWaste
        recycledWaste
        wasteForIncineration
        recyclingRate
        incinerationRate
        energyFromWaste
        CO2EmissionsGenerated
        CO2Saved
        treesSaved
      }
      dashboard {
        dataset
        customerSiteValue
        customerSiteLabel
        reducedWasteRate
        reducedWaste
        totalWeightCY
        totalWeightYA
        co2EmissionsGenerated
        emissionsRate
        percentage
        periodLabel
        periodValue
        recycledOrRecovered
        recyclingRate
        rorColorCode
        totalWeight
        wasteTypeLabel
        typeColorCode
        totalEmissions
        totalRecycled
        totalWaste
      }
    }
  }
`;

export const GET_HOME_DATA_TIPPING = gql`
  query GetHomeDataTipping($input: DataInput) {
    getHomeTippingData(input: $input) {
      dashboardTipping {
        achievementRow {
          title
          value
        }
        feeData {
          periodLabel
          periodValue
          totalFee
          totalRebate
        }
        tonnageData {
          periodValue
          periodLabel
          totalWeight
        }
        levelData {
          level
          tonnage
        }
      }
    }
  }
`;

export const GET_SUGGESTIONS = gql`
  query GetRandomizedSuggestions {
    getRandomizedSuggestions {
      data {
        attributes {
          image {
            data {
              attributes {
                url
              }
            }
          }
          title
          description
          linkUrl
        }
      }
    }
  }
`;

export const GET_LINKEDIN_LAST_POST = gql`
  query Query {
    getLinkedinLastPost
  }
`;

export const GET_EVENTBRITE_DATA = gql`
  query getEventBanner {
    eventBanners {
      data {
        attributes {
          title
          link
          image {
            data {
              attributes {
                url
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_JOBS_ISSUES = gql`
  query GetJobIssueList($input: DataInput) {
    getJobIssueDocList(input: $input) {
      issues {
        jobDate
        site
        jobNumber
        jobStatus
        jobIssueType
        responsibility
        issueStatus
        affectsServiceRate
      }
      jobs {
        jobDate
        site
        jobNumber
        arrTime
        depTime
        status
        service
        wasteType
        EWCCode
        weight
        quantity
        CO2Emissions
        downloadJobTicketFileName
        downloadJobTicketLink
      }
    }
  }
`;

export const GET_JOBS_TIPPING = gql`
  query GetJobTippingList($input: DataInput) {
    getJobTippingList(input: $input) {
      jobs {
        date
        vehicleRegNo
        round
        ticket
        arrivalTime
        departureTime
        turnaroundTime
        grossWeight
        tareWeight
        netWeight
        contaminationLevel
        gateFee
        totalFee
      }
      cardboard {
        date
        vehicleRegNo
        round
        ticket
        arrivalTime
        departureTime
        turnaroundTime
        grossWeight
        tareWeight
        netWeight
        contaminationLevel
        gateFee
        totalFee
      }
    }
  }
`;

export const GET_REPORT_DATA = gql`
  query GetReportData($isYtd: Boolean) {
    getCustomers {
      id
      customer
      reports(isYTD: $isYtd) {
        periodLabel
        excelDownloadFilepath
        PDFViewFilepath
        PDFDownloadFilepath
      }
      reportsTipping {
        periodLabel
        excelDownloadFilepath
        PDFViewFilepath
        PDFDownloadFilepath
      }
    }
  }
`;

export const GET_INVOICE_DATA = gql`
  query GetCustomers($input: InvoiceInput) {
    getCustomers {
      id
      customer
      invoices(input: $input) {
        invoiceNumber
        totalAmount
        invoiceType
        invoiceDate
        filePath
        creditedInvoiceNumber
      }
    }
  }
`;

export const GET_CUSTOMER_INVOICE_CHART = gql`
  query GetInvoiceChart($customerId: ID) {
    getInvoiceChart(customerId: $customerId) {
      MMMyyyy
      invoiceInclCreditNote
      creditNoteValue
    }
  }
`;

export const GET_DOCUMENT_DATA = gql`
  query Documents($input: DataInput) {
    getJobIssueDocList(input: $input) {
      documents {
        documentRef
        fileName
        endOfValidity
        documentType
        site
        filePath
        fileType
        source
      }
    }
  }
`;

export const DOWNLOAD_DOCUMENT_FILE = gql`
  query DownloadProtectedDocument($fileId: String!, $source: String!) {
    downloadProtectedDocument(fileId: $fileId, source: $source)
  }
`;
